import { config } from '@/config'

export default class DatatransService {
	constructor() {
		this.injected = false
		this.form = null
		this.formData = null
		this.uniqueId = 0
		this.scriptUrl = ""
	}
	async payment({amount, ref, sign, merchantId, checkoutComplete, successUrl, cancelUrl, errorUrl, additionalData = {}}) {
		if (!this.injected) {
			await this.injectScript()
		}

		this.formData = {
			merchantId,
			amount,
			"currency": "CHF",
			"refno": ref,
			"sign": sign,
			//"paymentmethod": "VIS",
			checkoutComplete,
			successUrl,
			cancelUrl,
			errorUrl,
			...additionalData
		}

		this.form = this.buildForm(this.formData)
		document.body.appendChild(this.form)

		const result = await this.processPayment()
		config.DEBUG && console.info("payment finished", result)
	}
	processPayment() {
		return new Promise((res, rej) => {
			if (typeof Datatrans == "object") {
				Datatrans.startPayment({
					form: "#" + this.form.id,
					opened: () => config.DEBUG && console.info("Datatrans: opened"),
					loaded: () => config.DEBUG && console.info("Datatrans: loaded"),
					closed: (arg) => { config.DEBUG && console.info("Datatrans: closed", arg); rej("closed") },
					error: (err) => { config.DEBUG && console.info("Datatrans: error", err, this.formData); rej(err) },
				})
			} else {
				rej(new Error("Datatrans integration failed"))
			}
		})
	}
	injectScript() {
		return new Promise((res, rej) => {
			const script = document.createElement("script")
			script.onload = () => {
				res()
			}
			script.src = this.scriptUrl
			document.head.appendChild(script)
		})
	}
	buildForm(data) {
		const form = document.createElement("form")
		form.id = "datatranspaymentform-" + this.uniqueId ++
		for (let [key, val] of Object.entries(data)) {
			if (val != undefined) {
				key = key.replace(/[A-Z]/g, (v) => "-" + v.toLowerCase())
				form.setAttribute(`data-${key}`, val.toString())
			}
		}
		return form
	}
}
